import React from "react";
import { PropTypes } from "prop-types"; 
import ModalHeader from 'react-bootstrap/ModalHeader';
import "./style.scss";
import Button from "../Button";

function MyModalHeader(props){
  return (
    <ModalHeader className={"modal_header "+props.className}>
      <div className="modal_header-container">
        {props.children}
      <Button onClick={props.handleHide} flat className={'modal_header-close_btn'} margin={'0'} >
        <span className="fa fa-times"/>
      </Button>
      </div>
    </ModalHeader>
  );
}

MyModalHeader.propTypes = {
  className:PropTypes.string,
  title:PropTypes.string,
  handleHide:PropTypes.any,
};
MyModalHeader.defaultProps = {
  className:'',
  title:'Modal title',
  handleHide:()=>{}
};
export default MyModalHeader;
